import { render, staticRenderFns } from "./FactChemistryElement.vue?vue&type=template&id=74091cd6&scoped=true&"
import script from "./FactChemistryElement.vue?vue&type=script&lang=js&"
export * from "./FactChemistryElement.vue?vue&type=script&lang=js&"
import style0 from "./FactChemistryElement.vue?vue&type=style&index=0&id=74091cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74091cd6",
  null
  
)

export default component.exports